import axios from "axios";
import authHeader from '../services/AuthHeader';
import jwt_decode from "jwt-decode";

import {ENV_URL} from './Globals';
const API_URL = `${ENV_URL}/api/auth/users/`;

class AuthService {
  
  login(email, password) {
    return axios
      .post(API_URL + "signin", {
        email,
        password
      })
      .then(response => {
        if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
        localStorage.setItem("expTime",JSON.parse(localStorage.getItem("user"))["accessToken"]);
        localStorage.setItem("expTimeInMS",jwt_decode(localStorage.getItem("expTime")).exp);
        }
        return response.data;
      });
  }
 
  logout() {
    localStorage.removeItem("user");
  }

  register(email, password) {
    return axios.post(API_URL + "signup", {
      email,
      password
    });
  }


  registerMOD(username, email, password) {
    return axios.post(API_URL + "signup/mod", {
      username,
      email,
      password
    }, {
      headers: authHeader()
    });
  }


  getCurrentUser() {
      return JSON.parse(localStorage.getItem('user'));; 

  }




  getUserRole() {
    const loggedUser = this.getCurrentUser();
    if(loggedUser != null) {
     if(Object.values(loggedUser.roles).includes('ROLE_ADMIN')) {
      return ('ADMIN');
    }
    if(Object.values(loggedUser.roles).includes('ROLE_MODERATOR')) {
      return ('MODERATOR');
  } if(Object.values(loggedUser.roles).includes('ROLE_BISH')) {
    return ('BISH');
  }
  else {
     return ('USER');
  }
}
  }

 getDisabledUsers() {
    return axios.get(API_URL + "disabled", {
        headers: authHeader()
    });
};


  enableUser(username) {
return axios.post(`${API_URL}enable/${username}`, null, {
  headers: authHeader()
});
};

disableUser(username) {
  return axios.post(`${API_URL}disable/${username}`, null, {
    headers: authHeader()
  });
  };


activateUser(username,token) {
  return axios.post(`${API_URL}active/${username}/${token}`, null, {
    headers: authHeader()
  });
  };



  activateBisharat(username,smsConfirmationToken) {
    return axios.post(`${API_URL}activebisharat/${username}/${smsConfirmationToken}`, null, {
      headers: authHeader()
    });
    };

    modifynumberconfirmation(username,smsConfirmationToken,newNumber) {
      return axios.post(`${API_URL}modifynumberconfirmation/${username}/${smsConfirmationToken}/${newNumber}`, null, {
        headers: authHeader()
      });
      };
  

getAllUsers() {
  return axios.get(API_URL, {
      headers: authHeader()
  });
};


getUserOne(userName) {
  return axios.get(`${API_URL}${userName}`, {
      headers: authHeader()
  });
};




getOneUserbyUserName(userName) {
  return axios.get(`${API_URL}${userName}`, {
      headers: authHeader()
  });
};


setAuthentications(userName, data) {
  return axios.post(`${API_URL}${userName}/setauthentication`, data , {
    headers: authHeader()
  });
}

ActivateBish(userName) {
  return axios.get(`${API_URL}${userName}/activatebish`, {
    headers: authHeader()
});
}

deActivateBish(userName) {
  return axios.get(`${API_URL}${userName}/deactivatebish`, {
    headers: authHeader()
});
}

ActivateModerator(userName) {
  return axios.get(`${API_URL}${userName}/activatemoderator`, {
    headers: authHeader()
});
}

deActivateModerator(userName) {
  return axios.get(`${API_URL}${userName}/deactivatemoderator`, {
    headers: authHeader()
});
}


isRequestToJoinBish(userName) {
  return axios.get(`${API_URL}${userName}/isrequestforbish`, {
    headers: authHeader()
});
}


getReqToJoinBish() {
  return axios.get(`${API_URL}getrequestjoinbisharat`, {
    headers: authHeader()
});
}


reqToJoinNow(username) {
  return axios.post(`${API_URL}${username}/requestnow`,null, {
    username    
  }, {
    headers: authHeader()
  });
}

unlockSMSForUser(username) {
  return axios.post(`${API_URL}unlocksmsuser/${username}`, {
    username    
  }, {
    headers: authHeader()
  });
}

getActivationLinkForUser(username) {
  return axios.get(`${API_URL}getactivationlink/${username}`, {
    headers: authHeader()
});
}




changePassword(username, oldPass, newPassword, newPasswordConfirmation) {
  return axios.post(`${API_URL}changepassword/${username}`, {
    oldPass,
    newPassword,
    newPasswordConfirmation
  }, {
    headers: authHeader()
  });
}


resetPassword(username,token, newPassword, newPasswordConfirmation) {
  return axios.post(`${API_URL}resetpassword/${username}/${token}`, {
    newPassword,
    newPasswordConfirmation
  }, {
    headers: authHeader()
  });
}


changeNumber(username,phonenumber) {
  return axios.post(`${API_URL}modifynumber/${username}/${phonenumber}`,  {
    headers: authHeader()
  });
}

resetUserOrPasswordViaEmail(email) {
  return axios.post(`${API_URL}resetpasswordoruser/${email}`,  {
    headers: authHeader()
  });
}
}

const authService = new AuthService();
export default authService;
